import { render } from "./ProductForm.vue?vue&type=template&id=04effc9a&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"

import "./ProductForm.vue?vue&type=style&index=0&id=04effc9a&scoped=true&lang=css"
import "./ProductForm.vue?vue&type=style&index=1&id=04effc9a&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04effc9a"]])

export default __exports__